import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import { useParams, useHistory, useLocation, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { product_actions, global_actions } from "../../../../redux-store";
import backend from "../../../../api";
import CommonAutocomplete from "../../../../utils/CommonAutocomplete";
import Modal from "react-responsive-modal";
import { Notification, upload_images, url_encode } from "../../../../utils";
import { Helmet } from "react-helmet";

const CreateProduct = (props) => {
  const inputRef = useRef(null);

  const {
    handleSubmit,
    register,
    errors,
    getValues,
    setValue,
    setError,
    reset,
    clearErrors,
  } = useForm();

  const history = useHistory();
  const { pathname } = useLocation();
  const { product_id } = useParams();

  const { user } = useSelector((state) => state.auth);
  const { data } = useSelector((state) => state.products);
  console.log(user);

  const dispatch = useDispatch();
  const [image, setImage] = useState([]);
  const [product, setProduct] = useState({});
  const [res, setRes] = useState();
  const [Request, setRequest] = useState();
  const [obj, setObj] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [state, setState] = useState("create");
  const [categories, setCategories] = useState([]);
  const [hasChanges, setHasChanges] = useState(false);
  const [images, setImages] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [disable, setDisable] = useState(false);

  useEffect(() => {
    const status = new Notification();
    dispatch(global_actions.loading(true));
    backend
      .get("/category", {
        params: { isActive: true, category_type: "product" },
      })
      .then(({ data }) => {
        setCategories(data.data);
      })
      .catch((error) => {
        status.set_toast(
          "error",
          error.response ? error.response.data.message : error.message
        );
      })
      .finally(() => {
        dispatch(global_actions.loading(false));
        status.show_toast();
      });
  }, []);

  useEffect(() => {
    if (user) {
      if (!pathname.includes(user?.user?.role)) {
        history.replace(`/dashboard/${user?.user?.role}`);
      }
      if (product_id) {
        const prod = data.find(
          (i) => i._id === product_id && i.merchant_user._id === user.user._id
        );
        const prodct = data.filter((i) => i._id === product_id);

        setProduct(prodct[0]);
        if (prod) {
          let arr = [];
          prod.product_images.map((i) => {
            let img = i.image;
            arr.push(img);
          });
          setImage(arr);

          setSelectedCategory(prod.product_category);

          Object.keys(prod)
            .filter((i) =>
              [
                "_id",
                "_v",
                "merchant_user",
                "product_images",
                "date_updated",
              ].every((j) => j !== i)
            )
            .forEach((key) => {
              let val = prod[key];
              if (key === "product_category") {
                val = prod[key]._id;
              }
              if (key === "adcard_expiry_date") {
                setValue(
                  key,
                  new Date(val)
                    .toISOString()
                    .replace(/T.*/, "")
                    .split("-")
                    .join("-")
                );
              }

              if (key !== "adcard_expiry_date") {
                setValue(key, val);
              }
            });
          setState("edit");
          setHasChanges(false);
        }
      } else {
        setState("create");
        reset();
        setImage([]);
        setSelectedCategory(null);
      }
    }
  }, [user, pathname, product_id, data, categories]);

  // use This function to render image before submitting
  const uploadImage = async (e) => {
    let arr = [];
    if (image.length < 5) {
      const media = new FormData();
      let count = image.length;
      Array.from(e.target.files).forEach((i) => {
        media.append("images", i);
        count += 1;
      });

      if (count <= 5) {
        dispatch(global_actions.loading(true));
        const res = await upload_images(media);
        dispatch(global_actions.loading(false));
        if (res.status !== 500) {
          setRes(res.data.images);
          res.data.images.map((i) => arr.push(i));
          setImage((image) => [...image, ...arr]);

          clearErrors("product_images");
        } else {
          const status = new Notification();
          status.set_toast("warning", res.data.message);
          status.show_toast();
        }
      } else {
        setError("product_images", {
          type: "manual",
          message: "You can select up to 5 images",
        });
      }
    } else {
      const status = new Notification();
      status.set_toast("warning", "You can only upload five images");
      status.show_toast();
    }
  };

  const removeImage = (val) => {
    setImage(image.filter((i) => i !== val));
  };

  useEffect(() => {}, [image]);

  const submitHandler = async () => {
    const data = getValues();

    setDisable(true);

    if (!selectedCategory) {
      setError("product_category", {
        type: "manual",
        message: "You must select a category.",
      });
      setDisable(false);
      return;
    }

    if (image.length === 0) {
      setError("product_images", {
        type: "manual",
        message: "You must upload at least one image.",
      });
      setDisable(false);
      return;
    }

    if (state === "create") {
      dispatch(
        product_actions.create_product({
          ...data,
          merchant_user: user.user._id,
          published: true,
          product_images: image.map((i) => ({
            image: i,
          })),
          product_category: selectedCategory?._id || "",
        })
      );
      history.push("/shop");
    } else if (state === "edit") {
      const status = new Notification();
      setDisable(true);
      setOpenModal(true);
      dispatch(global_actions.loading(true));

      if (product) {
        delete product.merchant_user;
        const data = getValues();
        let arr = Object.keys(product);

        let newObj = {};
        arr.map((item) => {
          if (product[item] != data[item]) {
            if (typeof data[item] !== "undefined") {
              newObj[item] = data[item];
            }
            if (typeof product[item] === "object") {
              if (product[item]._id !== data[item]) {
                newObj[item] = data[item];
              } else {
                delete newObj[item];
              }
            }
          }
        });

        newObj.product_category = selectedCategory?._id || "";

        dispatch(global_actions.loading(false));

        backend
          .post("/requestedproducts", {
            ...newObj,
            product: product_id,
            merchant_user: user.user._id,
            product_images: image.map((i) => ({
              image: i,
            })),
            Request_status: [
              {
                status: "pending",
                status_date: new Date(),
              },
            ],
          })
          .then(({ data }) => {
            setRequest(data.data);
          })
          .catch((error) => {
            status.set_toast(
              "error",
              error.response ? error.response.data.message : error.message
            );
          })
          .finally(() => {
            dispatch(global_actions.loading(false));
            status.show_toast();
            setDisable(false);
          });
      }
    }
  };

  const handleCategoryChange = (newValue) => {
    setSelectedCategory(newValue);
    setValue("product_category", newValue ? newValue._id : "");

    if (newValue) {
      clearErrors("product_category");
    }

    setHasChanges(true);
  };

  return (
    <>
      <Helmet>
        <title>eksplode! | {state[0].toUpperCase() + state.slice(1)} </title>
      </Helmet>
      <div className="dashboard">
        <div className="box-account box-info">
          <div className="box-head">
            <h2>{state[0].toUpperCase() + state.slice(1)} Product</h2>
          </div>
          <div className="row mt-3">
            <div className="col-lg-12 mx-auto register-page section-b-space">
              <div className="theme-card">
                <form className="theme-form">
                  <div className="form-row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="product_name">Product Name</label>
                        <input
                          type="text"
                          className="form-control mb-0"
                          id="product_name"
                          name="product_name"
                          placeholder="Product Name"
                          ref={register({
                            required: {
                              value: true,
                              message: "This Field is Required",
                            },
                          })}
                          onChange={() => setHasChanges(true)}
                        />
                        <label htmlFor="product_name" className="error">
                          {errors.product_name && errors.product_name.message}
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="category">Category</label>
                        <CommonAutocomplete
                          label="Select Category"
                          options={categories}
                          value={selectedCategory}
                          onChange={handleCategoryChange}
                          isDisabled={false}
                          getOptionLabel={(option) => option.category_name}
                          loading={false}
                          height={54}
                        />
                        <label htmlFor="category" className="error">
                          {errors.product_category &&
                            errors.product_category.message}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="product_discription">Description</label>
                        <textarea
                          type="text"
                          className="form-control mb-0"
                          id="product_discription"
                          name="product_discription"
                          placeholder="About the Product"
                          ref={register({
                            required: {
                              value: true,
                              message: "This Field is Required",
                            },
                          })}
                          rows="6"
                          onChange={() => setHasChanges(true)}
                        />
                        <label htmlFor="product_discription" className="error">
                          {errors.product_discription &&
                            errors.product_discription.message}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="product_price">Product Price</label>
                        <input
                          type="text"
                          className="form-control mb-0"
                          id="product_price"
                          name="product_price"
                          placeholder="Product Price (USD)"
                          ref={register({
                            required: {
                              value: true,
                              message: "This Field is Required",
                            },
                            pattern: {
                              value: /[\d]*/,
                            },
                          })}
                          onChange={() => setHasChanges(true)}
                        />
                        <label htmlFor="product_price" className="error">
                          {errors.product_price && errors.product_price.message}
                        </label>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="member_prize_type">
                          Member Prize Type
                        </label>
                        <select
                          type="password"
                          className="form-control mb-0"
                          id="member_prize_type"
                          name="member_prize_type"
                          ref={register({
                            required: {
                              value: true,
                              message: "This Field is Required",
                            },
                          })}
                          onChange={() => setHasChanges(true)}
                        >
                          <option selected value="">
                            Select Prize Type
                          </option>
                          <option value="value">Value (USD)</option>
                          <option value="percentage">Percentage</option>
                        </select>
                        <label htmlFor="member_prize_type" className="error">
                          {errors.member_prize_type &&
                            errors.member_prize_type.message}
                        </label>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="member_prize_value">
                          Member Prize Value
                        </label>
                        <input
                          type="text"
                          className="form-control mb-0"
                          id="member_prize_value"
                          name="member_prize_value"
                          placeholder="Member Prize Value (USD)"
                          ref={register({
                            required: {
                              value: true,
                              message: "This Field is Required",
                            },
                            pattern: {
                              value: /[\d]*/,
                            },
                          })}
                          onChange={() => setHasChanges(true)}
                        />
                        <label htmlFor="member_prize_value" className="error">
                          {errors.member_prize_value &&
                            errors.member_prize_value.message}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="sales_tax">Sales Tax (1%-100%)</label>
                        <input
                          type="number"
                          className="form-control mb-0"
                          id="sales_tax"
                          name="sales_tax"
                          placeholder="Sales Tax (%)"
                          ref={register({
                            required: {
                              value: true,
                              message: "Sales Tax is required",
                            },
                            min: {
                              value: 1,
                              message: "Sales Tax must be at least 1%",
                            },
                            max: {
                              value: 100,
                              message: "Sales Tax can't be greater than 100%",
                            },
                          })}
                          onChange={() => setHasChanges(true)}
                        />
                        <label htmlFor="sales_tax" className="error">
                          {errors.sales_tax && errors.sales_tax.message}
                        </label>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="stock_quantity">Stock Quantity</label>
                        <input
                          type="number"
                          className="form-control mb-0"
                          id="stock_quantity"
                          name="stock_quantity"
                          placeholder="Stock Quantity"
                          ref={register({
                            required: {
                              value: true,
                              message: "This Field is Required",
                            },
                            min: {
                              value: 0,
                              message: "Stock quantity cannot be less than 0",
                            },
                          })}
                          onChange={() => setHasChanges(true)}
                        />
                        <label htmlFor="stock_quantity" className="error">
                          {errors.stock_quantity &&
                            errors.stock_quantity.message}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="form-row">
                    {/* <div className='col-md-6'>
                    <div className='form-group'>
                      <label htmlFor='product_name'>Ad Card Expiry Date</label>
                      <input
                        type='date'
                        className='form-control mb-0'
                        id='adcard_expiry_date'
                        name='adcard_expiry_date'
                        ref={register({
                          required: {
                            value: true,
                            message: 'This Field is Required',
                          },
                        })}
                      />
                      <label htmlFor='adcard_expiry_date' className='error'>
                        {errors.adcard_expiry_date &&
                          errors.adcard_expiry_date.message}
                      </label>
                    </div>
                  </div> */}

                    <div className="col-6">
                      <div className="form-group">
                        <label htmlFor="upload_images">
                          Select Product Images
                        </label>
                        <input
                          type="file"
                          accept="image/*"
                          className="form-control mb-0"
                          id="upload_images"
                          name="product_images"
                          placeholder="Product Images"
                          multiple
                          ref={register({
                            validate: (value) =>
                              image.length > 0 ||
                              "At least one image is required",
                          })}
                          onChange={(e) => {
                            // const media = new FormData()
                            // let count = image.length
                            // Array.from(e.target.files).forEach((i) => {
                            //   media.append('images', i)
                            //   count += 1
                            // })

                            // if (count < 6) {
                            //   setImages(media)
                            // } else {
                            //   setError('product_images', {
                            //     type: 'manual',
                            //     message: 'You can select upto 5 images',
                            //   })
                            // }
                            setHasChanges(true);
                            uploadImage(e);
                          }}
                        />
                        <label htmlFor="upload_images" className="error">
                          {errors.product_images &&
                            errors.product_images.message}
                        </label>
                      </div>
                    </div>
                  </div>
                  <section className="section-b-space related-product">
                    <div className="row search-product">
                      {/* {image.map((im, index) => {
                      <div key={index} className='col-xl-2 col-md-4 col-sm-6'> */}

                      {image.map((img, index) => {
                        return (
                          <div
                            key={index}
                            className="col-xl-2 col-md-4 col-sm-4 mb-6"
                          >
                            <div className="product-box">
                              <div className="img-wrapper">
                                <div className="close-circle">
                                  <i
                                    className="fa fa-times ml-4"
                                    aria-hidden="true"
                                    onClick={() => {
                                      removeImage(img);
                                    }}
                                  />
                                  <img src={img} className="img-fluid" alt="" />
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}

                      {/* </div>
                          </div>
                        </div>
                      </div> */}
                      {/* } */}
                      {/* )} */}
                    </div>
                  </section>
                  {/* <section className='section-b-space related-product'>
                  <div className='container'>
                    <div className='row'>
                      <div className='col-12 product-related'>
                        <h2>All products</h2>
                      </div>
                    </div>
                    <div className='row search-product'>
                      {products.map((product, index) => (
                        <div key={index} className='col-xl-2 col-md-4 col-sm-6'>
                          <ProductItem
                            product={product}
                            symbol={symbol}
                            onAddToWishlistClicked={add_to_wishlist}
                            onAddToCartClicked={add_to_cart}
                            key={index}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </section> */}
                  {state === "edit" ? (
                    <div className="row justify-content-end">
                      <button
                        disabled={!hasChanges || disable}
                        className="btn btn-solid ml-auto"
                        onClick={handleSubmit(submitHandler)}
                      >
                        Request {state}
                      </button>
                    </div>
                  ) : (
                    <div className="row justify-content-end">
                      <button
                        disabled={disable}
                        className="btn btn-solid ml-auto"
                        onClick={handleSubmit(submitHandler)}
                      >
                        {state}
                      </button>
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <div className="container px-4 py-3">
          <div className="row">
            <div className="col-sm-7">
              <div className="box">
                <div className="box-title">
                  <h4>It can take upto 24 hours to respond to your request.</h4>
                  <h4>Thank you for your patience!</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-3 justify-content-center">
          {" "}
          *
          <button
            className="btn btn-solid"
            onClick={() => {
              setOpenModal(false);
              history.replace(history.replace("/shop"));
            }}
          >
            Confirm
          </button>
        </div>
      </Modal>
    </>
  );
};
export default CreateProduct;
